import { provinceValidatorApi } from '@/api';
import { get } from 'lodash';
import taxHelperStore from '../taxHelper';
import { encryptedParams } from '@/utils';
import { showErrorMessage } from '@/utils/taxUtil';

/** 山西（太原） */
class Shanxi_Ty {

  bsrs = [];
  bsrsList = [];
  
  mobile = '';
  smscodeId = '';

  /** 获取办税员列表 */
  getRoleList = (data) => {
    const params = {
      ...data,
      authentication: 'tpass.shanxi.chinatax.gov.cn'
    }
    return provinceValidatorApi.getBsyList(encryptedParams(params, ['userName', 'userPass']))
      .then((resp) => {
        const { mobile, uuid } = get(resp, 'data.data.data') || {};
        this.bsrs = [{ mobile, uuid }];
        this.mobile = mobile;
        this.bsrsList = [{
          label: mobile,
          value: uuid
        }];
        return this.bsrsList;
      })
      .catch(error => {
        showErrorMessage(error, '获取登录角色失败');
        return Promise.reject(error);
      })
  }

  /** 发送验证码 */
  sendCaptcha = ({ formData }) => {
    const { bsr } = formData;
    const { nsrsbh, serialNo, province } = taxHelperStore.authQueryParams;
    const params =  {
      serialNo,
      province,
      creditCode: nsrsbh,
      phoneNumber: this.mobile,
      authentication: 'tpass.shanxi.chinatax.gov.cn',
      uuid: bsr
    };
    return provinceValidatorApi.taxAuthSendCaptcha2(params)
      .then(resp => {
        const smscodeId = get(resp, 'data.data.smscode_id') || '';
        this.smscodeId = smscodeId;
      })
      .catch(error => {
        showErrorMessage(error, '发送验证码失败');
        return Promise.reject(error);
      });
  }

  /** 授权 */
  taxAuth = ({ formData, extra = {} }) => {
    const { nsrsbh, serialNo, province } = taxHelperStore.authQueryParams;
    const { captcha, bsr } = formData;
    const params = {
      'uuid': bsr,
      'smsCodeId': this.smscodeId,
      'smscodeId': this.smscodeId,
      'mobile': this.mobile,
      'yddh': this.mobile,
      'mobileCode': captcha,
      'captcha': captcha,
      'serialNo': serialNo,
      'creditCode': nsrsbh,
      'province': province,
      'authentication':'tpass.shanxi.chinatax.gov.cn',
      ...extra
    };
    return provinceValidatorApi.taxAuthCaptchaCommit(serialNo, params)
      .catch(error => {
        showErrorMessage(error, '发送验证码失败');
        return Promise.reject(error);
      });
  };

}

export default new Shanxi_Ty();